export default class PromiseCancellation {}

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason instanceof PromiseCancellation) {
    event.preventDefault()
  }
})
